import { isEmpty } from 'lodash'

import cpfOrCnpjValidate from 'helpers/validates/cpfOrCnpj'

import validations from 'constants/validations'

const { STRING_SCHEMA_TYPE } = validations

const cpfOrCnpj = {
  name: 'cpfOrCnpj',
  schemaType: STRING_SCHEMA_TYPE,
  method(message = 'CPF ou CNPJ inválido') {
    return this.test(
      'cpfOrCnpj',
      message,
      (value) => isEmpty(value) || cpfOrCnpjValidate.isValid(value),
    )
  },
}

export default cpfOrCnpj
